import { connect } from 'react-redux';
import IncomingCallModal from 'components/IncomingCallModal/IncomingCallModal';
import { closeFullScreenModal } from 'actions/FullScreenModal';
import {
  callActions,
  callSelectors,
  conferenceRemoteModerationSelectors,
  conferenceSelectors,
  remoteModeratorActions
} from '@lifesize/nucleus';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const browser = _get(state, 'app.browser', {});
  const incomingCalls = callSelectors.incomingCallsSelector(state);
  const isLockedByModerator = conferenceSelectors.selectIsLocked(state) && !activeCall.isModerator;
  const remoteModerationIsActive = conferenceRemoteModerationSelectors.selectIsActive(state);

  return {
    activeCall,
    browser,
    call: incomingCalls.length ? incomingCalls[0] : null,
    defaultAudioSetting: _get(state, 'app.settingsModal.defaultAudioSetting'),
    isAcquiringPrimaryStream: _get(state, 'nucleus.media.isAcquiringPrimaryStream'),
    isLockedByModerator,
    isVisible: incomingCalls.length > 0,
    remoteModerationIsActive
  };
};

const mapDispatchToProps = dispatch => ({
  answer: async (call, media, remoteModerationIsActive) => {
    await dispatch(closeFullScreenModal());
    if (remoteModerationIsActive) {
      await dispatch(remoteModeratorActions.leaveCurrent());
    }
    dispatch(callActions.answer(call, media));
  },
  add: (call) => {
    dispatch(callActions.add(call));
  },
  endAndAnswer: (call) => {
    dispatch(closeFullScreenModal());
    setTimeout(() => {
      dispatch(callActions.endAndAnswer(call));
    }, 0);
  },
  ignore: call => dispatch(callActions.ignore(call))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    answer: (call, media) => {
      dispatchProps.answer(call, media, stateProps.remoteModerationIsActive);
    } 
  }
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(IncomingCallModal);
